'use client';

import { UserSession } from '@/types/general';
import type { User } from '@/types/user';

import { msalInstance } from './msal';

function generateToken(): string {
  const arr = new Uint8Array(12);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (v) => v.toString(16).padStart(2, '0')).join('');
}

// const user = {
//   id: 'USR-000',
//   avatar: '/assets/avatar.png',
//   firstName: 'Sofia',
//   lastName: 'Rivers',
//   email: 'sofia@devias.io',
// } satisfies User;

export interface SignUpParams {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface SignInWithOAuthParams {
  provider: 'microsoft' | 'discord';
}

export interface SignInWithPasswordParams {
  email: string;
  password: string;
}

export interface ResetPasswordParams {
  email: string;
}

class AuthClient {
  async signUp(_: SignUpParams): Promise<{ error?: string }> {
    // Make API request

    // We do not handle the API, so we'll just generate a token and store it in localStorage.
    const token = generateToken();
    localStorage.setItem('custom-auth-token', token);

    return {};
  }

  async signInWithOAuth(params: SignInWithOAuthParams): Promise<{ userData?: UserSession; error?: string }> {
    // Make API request
    if (params.provider === 'microsoft') {
      await msalInstance.initialize();
      const loginResponse = await msalInstance.loginPopup({
        scopes: ['openid', 'profile', 'email'],
      });
      const idToken = loginResponse.idToken;
      const res = await fetch('/api/auth/login/microsoft', {
        method: 'POST',
        body: JSON.stringify({ token: idToken }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const result = await res.json();
      if (res.ok && result.success) {
        return { userData: result.data };
      }
    }
    return { error: 'Social authentication is coming soon' };
  }

  async signInWithPassword(params: SignInWithPasswordParams): Promise<{ userData?: UserSession; error?: string }> {
    const { email, password } = params;

    // Make API request
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    const result = await res.json();
    if (res.ok && result.success && result.data) {
      return { userData: result.data }; //in result I should receive user details to store it in redux
    }
    return { error: 'Invalid credentials' };

    // if (email !== 'sofia@devias.io' || password !== 'Secret1') {
    //   // We do not handle the API, so we'll check if the credentials match with the hardcoded ones.
    //   return { error: 'Invalid credentials' };
    // }

    // const token = generateToken();
    // localStorage.setItem('custom-auth-token', token);

    // return {};
  }

  async resetPassword(_: ResetPasswordParams): Promise<{ error?: string }> {
    return { error: 'Password reset not implemented' };
  }

  async updatePassword(_: ResetPasswordParams): Promise<{ error?: string }> {
    return { error: 'Update reset not implemented' };
  }

  async getUser(): Promise<{ data?: User | null; error?: string }> {
    // Make API request
    const res = await fetch('/api/auth/me');
    const result = await res.json();

    if (res.ok && result.success) {
      return { data: result.data };
    }
    // if (res.status === 401) {
    //   window.location.href = '/';
    // }

    // We do not handle the API, so just check if we have a token in localStorage.
    // const token = localStorage.getItem('custom-auth-token');

    // if (!token) {
    //   return { data: null };
    // }

    return { data: null };
  }

  async signOut(): Promise<{ error?: string }> {
    await fetch('/api/auth/logout');
    // localStorage.removeItem('custom-auth-token');
    return {};
  }
}

export const authClient = new AuthClient();
